import { render, staticRenderFns } from "./opportunities-widget.component.vue?vue&type=template&id=14572576&scoped=true"
import script from "./opportunities-widget.component.vue?vue&type=script&lang=ts"
export * from "./opportunities-widget.component.vue?vue&type=script&lang=ts"
import style0 from "./opportunities-widget.component.vue?vue&type=style&index=0&id=14572576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14572576",
  null
  
)

export default component.exports